import isEqual from 'lodash/isEqual';
import store from '@/store';
import { getSubApiTypes, getActiveSubApiTypes } from '@/utils/poi-utils'
import { getMapCenter } from '@/utils/map-utils';
import defaultSettings from '@/data/poiSettingsDefaults'
import { getPoiConfig } from '@/utils/poi-data/poi-config'

const baseParams = {}
let typeSettings = {};
export const getPoiParams = (type, subType = false) => {
    typeSettings = store.getters.poiSettings[type] ? store.getters.poiSettings[type] : {};

    if(store.getters.queryPoiSettings) {
        typeSettings = store.getters.queryPoiSettings[type] ? store.getters.queryPoiSettings[type] : {}
    }

    // if(!typeSettings) {
    //     return false;
    // }

    let params = {
        ...baseParams,
    }

    const geographic = getGeographicParams();
    if(geographic) {
        params.geographic = geographic;
    }

    const categories = getCategories();
    if(categories) {
        params.category = {
            values: categories
        };
    }

    const types = getTypes(type);
    if(types) {
        if(type === 'favourites') {
            params.type = types
        } else {
            params.type = {
                values: types
            };
        }
    }

    const openingHours = getOpeningHours();
    if(openingHours) {
        params.openingHours = openingHours;
    }

    const ratings = getRatings();
    if(ratings) {
        params.ratings = ratings;
    }

    const accessible = getAccessible();
    if(accessible) {
        params.accessible = accessible;
    }

    const operator = getOperator(type);
    if(operator) {
        params.operator = operator;
    }

    const time = getTime(type);
    if(time) {
        params.time = time;
    }

    const services = getServices()
    if(services) {
        params.services = services
    }

    const operationMode = getOperationMode()
    if(operationMode) {
        params.operationMode = operationMode
    }

    const fuels = getFuels()
    if(fuels) {
        params.fuels = {
            fuels: fuels
        }
    }

    const radius = getRadius()
    if(radius) {
        params.radius = radius
    }

    const facility = getFacilityOptions()
    if(facility) {
        params.facility = facility
    }

    const roadConnection = getRoadConnection()
    if(roadConnection) {
        params.roadConnection = roadConnection
    }

    const efuels = getEfuels(type)
    if(efuels) {
        params.efuels = efuels
    }

    const favouritesOnly = getFavouritesOnly()
    if(favouritesOnly) {
        const favouriteTypes = getFavouriteTypes(type, params)
        params.favouriteOnly = true
        const favouriteIds = getFavouriteIdsForTypes(favouriteTypes)
        if(favouriteIds) {
            params.ids = favouriteIds
        } else {
            params.ids = { list: [] }
        }
    }

    const favouriteListIds = getFavouriteListIds()
    if(favouriteListIds) {
        params.favoriteListIds = favouriteListIds
    }

    // remove category and type for subtype params – always do this last
    if(subType) {
        if(params.category) delete params.category
        // if(params.type && subType !== 'prediction') delete params.type
        if(params.type) delete params.type
    }

    return params;
}

function getGeographicParams() {
    const geographic = {}
    const corridor = store.getters.routeCorridor;
    const radius = store.getters.routeCorridorRadius
    if(corridor && radius !== 1000) { // 1000 is all 
        const routeCorridor = getCurrentRouteCorridor(corridor, radius)
        geographic.corridor = routeCorridor
    }

    geographic.boundingBox = getCurrentBoundingBox()

    return geographic
}

export function getCurrentRouteCorridor(corridor, radius) {
    return {
        polylineWKT: corridor,
        radius: radius
    }
}

export function getCurrentBoundingBox() {
    const bounds = store.getters.mapBounds;
    if(!bounds) return false;
    const northWest = bounds.getNorthWest()
    const southEast = bounds.getSouthEast()
    return {
        longitudeMin: northWest.lng,
        longitudeMax: southEast.lng,
        latitudeMin: southEast.lat,
        latitudeMax: northWest.lat,
    }
}

function getCategories() {
    return typeSettings.categories ? typeSettings.categories : false;
}

function getTypes(type) {
    if(type === 'favourites') {
        if(!store.getters.favouriteCategories || store.getters.favouriteCategories.length === 0) return false
        const types = []
        store.getters.favouriteCategories.forEach(category => {
            if(!typeSettings.uncheckedCategories.includes(category.value)) {
                const poiConfig = getPoiConfig(category.value);
                if(poiConfig) {
                    if(poiConfig.favouriteType) types.push(poiConfig.favouriteType)
                    if(poiConfig.categories) {
                        poiConfig.categories.forEach(poiCategory => {
                            if(poiCategory.favouriteType) types.push(poiCategory.favouriteType)
                        })
                    }
                }
                if(category.value === 'ADDRESS') {
                    types.push('ADDRESS')
                }
            }
        })
        return types
    }

    const poiConfig = getPoiConfig(type);
    if(!typeSettings.type) return false;
    if(!poiConfig.categories) return false;
    if(!poiConfig.categories.find(category => category.children)) return typeSettings.type;
    let types = [];
    typeSettings.type.forEach(typeElement => {
        const poiConfigItem = poiConfig.categories.find(category => category.value === typeElement);
        if(!poiConfigItem) return false
        if(poiConfigItem.skipParam) return false;
        if(poiConfigItem.children) {
            poiConfigItem.children.forEach(child => {
                types.push(child.value);
            })
        } else {
            types.push(typeElement);
        }
    });
    return types;
}

function getOpeningHours() {
    let openingHours = {};
    if (typeSettings.other) {
        if(typeSettings.other.openNextHour) {
            openingHours.openNextHour = typeSettings.other.openNextHour;
        }
        if(typeSettings.other.openAllDay) {
            openingHours.openAllDay = typeSettings.other.openAllDay;
        }
    }
    return Object.keys(openingHours).length ? openingHours : false;
}

function getRatings() {
    let ratings = {};
    if(typeSettings.ratings) {
        if(typeSettings.ratings.oeamtcPartner) {
            ratings.oeamtcPartner = typeSettings.ratings.oeamtcPartner;
        }
    } else if (typeSettings.other) {
        if(typeSettings.other.oeamtcPartner) {
            ratings.oeamtcPartner = typeSettings.other.oeamtcPartner;
        } 
    }
    return Object.keys(ratings).length ? ratings : false;
}

function getAccessible() {
    let accessible = {};
    if(typeSettings.accessible) {
        if(typeSettings.accessible.accessible) {
            accessible.accessible = typeSettings.accessible.accessible;
        }
    } else if (typeSettings.other) {
        if(typeSettings.other.accessible) {
            accessible.accessible = typeSettings.other.accessible;
        }
    }
    return Object.keys(accessible).length ? accessible : false;
}

function getOperator(type) {
    let operator = {};
    const poiConfig = getPoiConfig(type);
    if(typeSettings.operator && typeSettings.operator.length) {
        operator.values = typeSettings.operator;

        //for parking, if Diverse is selected, ignore the unchecked values
        if(type === 'carParks' && typeSettings.operator.length > 0 && typeSettings.operator.includes('Diverse')) {
            operator = {}
            const allOperatorValues = poiConfig.operators.map(o => o.value)
            operator.ignoredValues = []
            allOperatorValues.forEach(value => {
                if(!typeSettings.operator.includes(value) && value !== 'Diverse') {
                    operator.ignoredValues.push(value)
                }
            })
        }

        // if it's gasStations, the names of the operator has to be send instead of the value
        if(type === 'gasStations' && typeSettings.operator.length > 0) {
            const operatorNames = []
            typeSettings.operator.forEach(value => {
                const matchingCategory = poiConfig.categories[0].children.find(category => category.value === parseInt(value))
                if(matchingCategory) operatorNames.push(matchingCategory.label)
            })
            operator.values = operatorNames

            // if Sonstiges is selected, ignore the unchecked values
            if(operatorNames.includes('Sonstige')) {
                const allCategoryValues = poiConfig.categories[0].children.map(c => c.label)
                operator.ignoredValues = []
                allCategoryValues.forEach(value => {
                    if(!operatorNames.includes(value) && value !== 'Sonstige') {
                        operator.ignoredValues.push(value)
                    }
                })
                delete operator.values // delete the operator values to get correct (inversed) results
            }
        }
    }
    return Object.keys(operator).length ? operator : false;
}

function getTime(type) {
    if(type !== 'traffic') return false;
    const trafficTime = store.getters.savedRouteTime || store.getters.routeTrafficTime;
    const hoursToAdd = 2
    let startTime
    let endTime
    let isPrediction = false
    if(trafficTime.isNow) {
        startTime = new Date()
        endTime = new Date()
        endTime.setHours(endTime.getHours() +  hoursToAdd);
    } else {
        const splitTime = trafficTime.time.split(':')
        startTime = new Date(trafficTime.date)
        startTime.setHours(splitTime[0], splitTime[1])
        endTime = new Date(trafficTime.date)
        endTime.setHours(parseInt(splitTime[0]) +  hoursToAdd, splitTime[1]);
        isPrediction = true
    }
    return {
        futureOnly: false,
        periodFrom: startTime,
        periodTo: endTime,
        prediction: isPrediction
    }
}

export function getCommonBoundingBox(storedBoundingBox) {
    const currentMapBounds = store.getters.mapBounds;
    const currentNorthWest = currentMapBounds.getNorthWest()
    const currentSouthEast = currentMapBounds.getSouthEast()
    return {
        longitudeMin: storedBoundingBox.longitudeMin > currentNorthWest.lng ? storedBoundingBox.longitudeMin : currentNorthWest.lng,
        longitudeMax: storedBoundingBox.longitudeMax < currentSouthEast.lng ? storedBoundingBox.longitudeMax : currentSouthEast.lng,
        latitudeMin: storedBoundingBox.latitudeMin > currentSouthEast.lat ? storedBoundingBox.latitudeMin : currentSouthEast.lat,
        latitudeMax: storedBoundingBox.latitudeMax < currentNorthWest.lat ? storedBoundingBox.latitudeMax : currentNorthWest.lat,
    }
}

function getServices() {
    const services = {}
    if(typeSettings.services && typeSettings.services.length) {
        services.services = {
            values: typeSettings.services,
            operator: 'AND',
        }
    }
    return Object.keys(services).length ? services : false;
}

function getOperationMode() {
    let operationMode = {}
    if(typeSettings.operationMode && typeSettings.operationMode.length) {
        operationMode.operationMode = typeSettings.operationMode;
    }
    return Object.keys(operationMode).length ? operationMode : false;
}

function getFuels() {
    let fuels = {}
    if(typeSettings.fuels && typeSettings.fuels.length) {
        fuels.values = typeSettings.fuels
    }
    return fuels.values ? fuels : false
}

function getRadius() {
    let radius = false
    if(typeSettings.radius && typeSettings.radius > 0) {
        radius = typeSettings.radius
    }
    return radius
}

function getFacilityOptions() {
    let facilityOptions = {}
    if(typeSettings.facility) {
        if(typeSettings.facility.changingTable) {
            if(facilityOptions.child === undefined) facilityOptions.child = {}
            facilityOptions.child.changingTable = typeSettings.facility.changingTable
        }
        if(typeSettings.facility.playground) {
            if(facilityOptions.child === undefined) facilityOptions.child = {}
            facilityOptions.child.playground = typeSettings.facility.playground
        }
    }
    return Object.keys(facilityOptions).length ? facilityOptions : false;
}

function getRoadConnection() {
    let roadConnection = {}
    if(typeSettings.roadConnection) {
        if(typeSettings.roadConnection.suitableForCampers) {
            roadConnection.suitableForCampers = typeSettings.roadConnection.suitableForCampers
        } 
        if(typeSettings.roadConnection.openAllYear) {
            roadConnection.openAllYear = typeSettings.roadConnection.openAllYear
        }
    }
    return Object.keys(roadConnection).length ? roadConnection : false;
}

function getFavouritesOnly() {
    let favouritesOnly = false
     if (typeSettings.other) {
        if(typeSettings.other.favouritesOnly) {
            favouritesOnly = typeSettings.other.favouritesOnly;
        } 
    }
    return favouritesOnly
}

function getFavouriteTypes(type, params) {
    let types = []

    const config = getPoiConfig(type)
    const hasSubApis = getSubApiTypes(type).length > 0
    if(config.favouriteType) {
        types.push(config.favouriteType)
    }
    if(hasSubApis) {
        const activeSubApiTypes = getActiveSubApiTypes(config, params, false)
        config.categories.forEach(category => {
            if(activeSubApiTypes && activeSubApiTypes.includes(category.apiType) && category.favouriteType) {
                types.push(category.favouriteType)
            }
        })
    }
    return types
}

function getFavouriteIdsForTypes(types) {
    const ids = []
    types.forEach(type => {
        const allFavourites = store.getters.allFavourites
        const favouritesWithType = allFavourites.filter(favourite => (favourite.type && favourite.type === type) || (favourite.poicat && favourite.poicat === type))
        favouritesWithType.forEach(favourite => {
            ids.push(favourite.objectId)
        })
    })
    return ids.length > 0 ? { list: ids } : false
}

export function getTypesCategoriesForMulti(poiType, categories, favouritesOnly = false) {
    const params = {
        type: [],
        category: {
            values: []
        }
    }
    if(categories.length === 0) return params
    let selectedCategories = [...categories]
    let mainCategory
    let mainSubCategories
    switch(poiType) {
        case('parking'):
            mainCategory = 'PARKING'
            mainSubCategories = store.getters.mapZoom && store.getters.mapZoom >= 11 ? ['SHORTTERMPARKING'] : []
            break;
        case('traffic'):
            mainCategory = 'TRAFFIC'
            mainSubCategories = ['CAMERA']
            break;
        case('partner'):
            // partners are an exception, all their categories are a main type
            params.type = selectedCategories
            break;
        default:
            mainCategory = false
            mainSubCategories = false
    }
    if(mainCategory && mainSubCategories) {
        mainSubCategories.forEach(mainSubCategory => {
            if(selectedCategories.includes(mainSubCategory)) {
                params.type.push(mainSubCategory)
                // remove the mainsubcategory from the array
                selectedCategories = selectedCategories.filter(item => item !== mainSubCategory)
            }
        })
        // if there are still items in the array, they belong to the main category
        if(selectedCategories.length > 0) {
            params.type.push(mainCategory)
            params.category.values = selectedCategories
        }
    }
    // special case traffic: always send prediction main category & subcategories if not camera is the only selection
    if(poiType === 'traffic') {
        // if favouritesOnly, only ask for cameras
        // if only camera is selected, only ask for camera
        if(favouritesOnly || (params.type.length === 1 && params.type[0] === 'CAMERA' && params.category.values.length === 0)) {
            params.type = ['CAMERA']
        } else {
            params.type.push('TRAFFIC_PREDICTION')
            params.category.values = [...params.category.values, 'Prognose', 'PrognoseOrange', 'PrognoseRot']
        }
    }
    return params
}

export function getNearbyStationCoordinates(params = false) {
    let userCoordinates = store.getters.userCoordinates;
    const userLocationIsUserCoordinates = store.getters.userLocationIsUserCoordinates
    let nearbyStationCoordinates = !userLocationIsUserCoordinates && userCoordinates ? { ...userCoordinates } : false
    if(!nearbyStationCoordinates) {
        nearbyStationCoordinates = getMapCenter();
    }
    if(params && params.forcedCoordinates) {
        nearbyStationCoordinates = params.forcedCoordinates
    }

    const coordinates = {
        longitude: nearbyStationCoordinates.lon ? nearbyStationCoordinates.lon : nearbyStationCoordinates.longitude,
        latitude: nearbyStationCoordinates.lat ? nearbyStationCoordinates.lat : nearbyStationCoordinates.latitude,
    }

    return coordinates
}

function getFavouriteListIds() {
    if(typeSettings.uncheckedLists && typeSettings.uncheckedLists.length > 0) {
        const listIds = []
        const allFavouriteLists = store.getters.favouritesLists
        allFavouriteLists.forEach(list => {
            if(!typeSettings.uncheckedLists.includes(list.id)) listIds.push(list.id)
        })
        if(!typeSettings.uncheckedLists.includes('')) listIds.push('')
        return listIds.length > 0 ? listIds : false
    }
    return false
}

function getEfuels(type) {
    const efuels = {}
    const poiConfig = getPoiConfig(type);
    const poiDefaultSettings = defaultSettings[type]
    if(typeSettings.plugTypes && typeSettings.plugTypes.length > 0) {
        let plugs = [...typeSettings.plugTypes]
        let settingsPlugs  = [...plugs].sort()
        let configPlugs = poiConfig.plugs.map(p => p.value).sort()
        if(isEqual(settingsPlugs, configPlugs)) {
            efuels.plugTypes = {}
        } else {
            poiConfig.plugs.forEach(cPlug => {
                if(typeSettings.plugTypes.includes(cPlug.value) && cPlug.subValues) {
                    plugs = [...plugs, ...cPlug.subValues]
                }
            })

            efuels.plugTypes = {
                values: plugs
            }
        }
    }

    if( typeSettings.capacity && 
        typeSettings.capacity.length === 2 && 
        (typeSettings.capacity[0] !== poiDefaultSettings.capacity[0] ||
        typeSettings.capacity[1] !== poiDefaultSettings.capacity[1])
    ) {
        efuels.capacitiesKw = {
            ranges: [
                {
                    from: typeSettings.capacity[0],
                    to: typeSettings.capacity[1],
                }
            ]
        }
    }
    if(typeSettings.other) {
        if(typeSettings.other.free === true) {
            efuels.chargingPointsCost = 'FREE'
        }
        if(typeSettings.other.greenEnergy === true) {
            efuels.greenEnergy = true
        }
        if(typeSettings.other.oeamtcEPower === true) {
            efuels.oeamtcEPowerStation = true
        }
    }

    return Object.keys(efuels).length ? efuels : false;
}